module.exports = __webpack_public_path__ + "static/dan-demo-blocking-6721b0c6de652af365bb6e635e64d3b6.png";